import React from 'react';
import {Tooltip} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {ComplianceIcon} from '../utils/icons';
import {Colors} from '../utils/style/colors';
import {moduleIds} from '../utils/models/Module';

// Inputs that may receive sensitive data get a warning when ISO 27001 / NEN 7510 is enabled
export const hasComplianceModule = user => !!user && (user.hasModule(moduleIds.Iso27001) || user.hasModule(moduleIds.Nen7510));

// Always rendered (with an empty title when not shown), so toggling `show` never remounts the input
export const PossiblySensitiveTooltip = ({show, open, children}) => {
    const [t] = useTranslation();
    return (
        <Tooltip
            title={show ? t('input.compliancyWarning') : ''}
            open={!!show && !!open}
            placement="top"
            describeChild
            disableHoverListener
            disableFocusListener
            disableTouchListener>
            {children}
        </Tooltip>
    );
};

const PossiblySensitiveIcon = ({onHoverChange}) => (
    <span
        style={{lineHeight: 0, opacity: .7}}
        onMouseEnter={() => onHoverChange && onHoverChange(true)}
        onMouseLeave={() => onHoverChange && onHoverChange(false)}>
        <ComplianceIcon size="20px" color={Colors.orange}/>
    </span>
);

export default PossiblySensitiveIcon;
